/** Shared education route; deployments can override the destination. */
export const TRAINING_URL =
  import.meta.env.VITE_TRAINING_URL ?? "/education";

/** External destinations open in a new tab. */
export const IS_TRAINING_EXTERNAL = /^https?:\/\//.test(TRAINING_URL);

/** Страница WMT Kids, на которую ведёт карточка «05. Обучение для детей». */
export const WMT_KIDS_URL =
  import.meta.env.VITE_WMT_KIDS_URL ??
  "https://wmt-ai.ru/kids/";
